import React from 'react';
import { useRootStore } from 'store';
import { Row } from 'react-bootstrap';
import { FormFilterCard, YupStringReq, YupNumericReq, FormCol } from 'motion-components';
import * as Yup from 'yup';
import { SelectContributionYear } from '../components/SelectContributionYear';
import { FieldSelectCntItems, FieldSelectContributionPeriod } from '../components';

/* ----------- Filters ------------------ */
export const Filters = ({ onChange, initialValues }) => {
  //
  const { appStore } = useRootStore();
  function handleFiltersSubmit(values, { setSubmitting }) {
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }
  console.log('filters-init ', initialValues);

  const filters = {
    fromPeriodId: initialValues?.fromPeriodId ?? '',
    fromYear: initialValues?.fromYear ?? '',
    tillPeriodId: initialValues?.tillPeriodId ?? '',
    tillYear: initialValues?.tillYear ?? '',
  };

  //const { values } = useFormikContext();
  const formShape = {
    fromPeriodId: YupNumericReq,
    fromYear: YupStringReq,
    tillPeriodId: YupNumericReq,
    tillYear: YupStringReq,
  };

  const validationSchema = Yup.object().shape(formShape);
  return (
    <FormFilterCard
      title="Κριτήρια Αναζήτησης"
      onSubmit={handleFiltersSubmit}
      initialValues={{
        fromPeriodId: filters?.fromPeriodId,
        fromYear: filters?.fromYear,
        tillPeriodId: filters?.tillPeriodId,
        tillYear: filters?.tillYear,
      }}
      validationSchema={validationSchema}
    >
      <Row>
        <FieldSelectContributionPeriod
          name="fromPeriodId"
          label="Από Περίοδο"
          //   required={true}
          as={FormCol}
        />
        <SelectContributionYear name="fromYear" title="Από Έτος" required={true} />
        <FieldSelectContributionPeriod
          name="tillPeriodId"
          label="Έως Περίοδο"
          //   required={true}
          as={FormCol}
        />
        <SelectContributionYear name="tillYear" title="Έως Έτος" required={true} />
      </Row>
    </FormFilterCard>
  );
};

